import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { init as initFullStory, FullStory } from "@fullstory/browser";

initFullStory({
  orgId: "o-22JDQB-na1",
  devMode:
    import.meta.env.DEV ||
    navigator.webdriver ||
    window.location.hostname.includes(".ci"),
});

if (!import.meta.env.DEV) {
  FullStory("setProperties", {
    type: "user",
    properties: {
      environment: window.location.hostname
        .replace("dashboard.", "")
        .replace(".edgify.ai", ""),
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
